<template>
  <base-nav
    container-classes="container-fluid"
    class="navbar-top navbar-expand"
    :class="{'bg-white': type === 'default'}"
  >
    <!-- Search form -->
    <b-form class="navbar-search form-inline"
          :class="{'navbar-search-light': type === 'default', 'navbar-search-dark': type === 'light'}"
          id="navbar-search-main">
      <b-form-group class="mb-0">
      </b-form-group>
      <button type="button" class="close" data-action="search-close" data-target="#navbar-search-main" aria-label="Close">
        <span aria-hidden="true">×</span>
      </button>
    </b-form>
    <!-- Navbar links -->
    <b-navbar-nav class=" align-items-center ml-md-0">
      <!-- This item dont have <b-nav-item> because they add class 'nav-link' which is not needed here -->
      <li class="nav-item d-xl-none">
        <!-- Sidenav toggler -->
        <div class="pr-3 sidenav-toggler"
             :class="{active: $sidebar.showSidebar, 'sidenav-toggler-dark': type === 'default', 'sidenav-toggler-light': type === 'light'}"
             @click="toggleSidebar">
          <div class="sidenav-toggler-inner">
            <i class="sidenav-toggler-line"></i>
            <i class="sidenav-toggler-line"></i>
            <i class="sidenav-toggler-line"></i>
          </div>
        </div>
      </li>
      <p class="font-weight-bold mr-3" v-if="auth_user.subscription.privileges.scpk_name.toLowerCase() !== 'corporate' && auth_user.subscription.scrb_is_my_own ">
        <span class="text-primary">
          <b-icon icon="caret-right-fill" class="mr-1"></b-icon>
          <router-link v-if="isEmpty(nextPackage)" to="/upgrade">Upgrade</router-link>
          <router-link v-if="!isEmpty(nextPackage) && nextPackage.next_pckg_name" to="/upgrade">Upgrade to {{ nextPackage.next_pckg_name.toLowerCase() }} plan</router-link>
        </span> 
        {{ (isEmpty(nextPackage)) ? " your plan to enjoy more features." : " to enjoy more features." }}
      </p>
      <a class="badge bg-fintos text-dark d-flex align-items-center px-2" href="javascript:void" v-if="version != _gAuth.appVersion()" style="font-size: 11px;">
          <b-icon icon="exclamation-triangle-fill" class="mr-1"></b-icon>New version available: V{{ version }} - Please refresh page, clear cache or logout & login again.
      </a>
    </b-navbar-nav>
    <b-navbar-nav class="align-items-center ml-auto mr-md-0">
      <!-- notifications -->
      <base-dropdown menu-on-right
                     class="nav-item"
                     tag="li"
                     title-tag="a"
                     title-classes="nav-link pr-0">
         <a href="javascript:void(0)" class="nav-link pr-0" @click.prevent slot="title-container">
            <b-media no-body class="align-items-center">
                <span class="avatar avatar-sm bg-white rounded-circle text-dark pt-2 position-relative">
                  <h2><b-icon icon="bell">
                  </b-icon></h2>
                  <span 
                    class="position-absolute top-0 right-0 text-white text-center bg-danger rounded-circle font-weight-bold" 
                    style="width:22px;height:22px;font-size:10px;padding-top:3px"
                    v-if="unread_notifications.length > 0"
                  >{{unread_notifications.length}}</span>
                </span>
            </b-media>
          </a>
        <template>
          <b-dropdown-header class="noti-title" style="min-width: 300px;">
            <div class="d-flex align-items-center justify-content-between">
              <h6 class="text-overflow m-0">Notifications</h6>
              <!-- <h6 class="text-overflow m-0"><a href="javascript:void(0)" @click="
              ">All</a></h6> -->

              <b-dropdown class="category-dropdown" right>
                <template #button-content>
                  <span class="h6 m-0">CATEGORY</span>
                </template>
                <b-dropdown-item
                  v-for="category in notificationCategories"
                  :key="category"
                  :class="{'bg-light': selectedCategory === category}"
                  @click.stop="filterNotifications(category)"
                >
                  {{ category }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </b-dropdown-header>
          <div class="px-1" style="max-height: 300px; overflow-y: scroll;">
            <ul class="list-group list-group-flush text-dark" v-if="filteredNotifications.length > 0">
              <li class="list-group-item pt-2 pb-1 px-3" :class="notification.noti_read_at ? '':'bg-fintos'" 
                @click.stop="markAsReadHandler(notification)"
                v-for="(notification, index) in filteredNotifications"
                :key="index"
              >
                <small>{{ notification.noti_message }}</small>
                <div class="d-flex justify-content-between mt-2 p-0">
                  <small :class="notification.noti_read_at ? 'text-muted':'text-dark'" style="font-size:10px">{{ notification.created_at | dateFormatString }}</small>
                </div>
              </li>
            </ul>
            <div class="px-2" v-else>
              <small class="px-1">You have no notifications.</small>
            </div>
          </div>
          <div v-if="unread_notifications.length > 0">
            <div class="dropdown-divider"></div>
            <div class="text-center"> 
              <a href="javascript:void(0)" @click.stop="markAllAsRead">
                <small>Mark all as read.</small>
              </a>
            </div>
          </div>
        </template>
      </base-dropdown>

      <!-- user profile -->
      <base-dropdown menu-on-right
                     class="nav-item"
                     tag="li"
                     title-tag="a"
                     title-classes="nav-link pr-0">
         <a href="javascript:void(0)" class="nav-link pr-0" @click.prevent slot="title-container">
            <b-media no-body class="align-items-center" v-if="auth_user">
                    <span class="avatar avatar-sm bg-dark rounded-circle text-white">
                      <b>{{ _gHlp.formatInitials(auth_user.name) }}</b>
                    </span>
            </b-media>
          </a>
        <template>

          <b-dropdown-header class="noti-title">
            <h6 class="text-overflow m-0">Welcome, {{ auth_user.name }}</h6>
          </b-dropdown-header>
          <b-dropdown-item @click="myProfile()">
            <i class="ni ni-single-02"></i>
            <span>My profile</span>
          </b-dropdown-item>
          <b-dropdown-item @click="modals.show_tnc = true">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 384 512"><path fill="currentColor" d="M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0zm192 0v128h128zM80 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16m0 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16m54.2 253.8c-6.1 20.3-24.8 34.2-46 34.2H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h8.2c7.1 0 13.3-4.6 15.3-11.4l14.9-49.5c3.4-11.3 13.8-19.1 25.6-19.1s22.2 7.7 25.6 19.1l11.6 38.6c7.4-6.2 16.8-9.7 26.8-9.7c15.9 0 30.4 9 37.5 23.2l4.4 8.8H304c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-6.1 0-11.6-3.4-14.3-8.8l-8.8-17.7c-1.7-3.4-5.1-5.5-8.8-5.5s-7.2 2.1-8.8 5.5l-8.8 17.7c-2.9 5.9-9.2 9.4-15.7 8.8s-12.1-5.1-13.9-11.3L144 349z"/></svg>
            <span>Terms &amp; Condition</span>
          </b-dropdown-item>
          <div class="dropdown-divider"></div>
          <b-dropdown-item @click="logoutFunction">
            <i class="ni ni-user-run"></i>
            <span>Logout</span>
          </b-dropdown-item>

          <TncModal :show_tnc.sync="modals.show_tnc" />

        </template>
      </base-dropdown>
    </b-navbar-nav>
  </base-nav>
</template>
<script>
import { BaseNav } from '@/components';
import { mapActions, mapState } from 'pinia'
import { useAuthStore } from '@/stores/authStore'
import { useNotificationStore } from '@/stores/notificationStore'
import {
      helperFunctionMixin,
    } from '@/assets/js/httpImports.js'
import TncModal from './TncModal.vue';

export default {
  components: {
    BaseNav,
    TncModal
  },
  mixins:[helperFunctionMixin],
  props: {
    type: {
      type: String,
      default: 'default', // default|light
      description: 'Look of the dashboard navbar. Default (Green) or light (gray)'
    }
  },
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
     ...mapState(useAuthStore,['auth_user']),
     ...mapState(useNotificationStore,['notifications', 'unread_notifications', 'navbar_notifications']),
		 nextPackage(){
			return (!this.isEmpty(this.auth_user.subscription) && !this.isEmpty(this.auth_user.subscription.next_package)) ? this.auth_user.subscription.next_package : null;
		 },
     filteredNotifications() {
      if (this.selectedCategory === 'Customer') {
        return this.navbar_notifications.filter(notification => notification.noti_related_type === 'customer' && !notification.noti_message.toLowerCase().includes('loan advisory'));
      } else if (this.selectedCategory === 'Leads') {
        return this.navbar_notifications.filter(notification => notification.noti_related_type === 'lead');
      } else if (this.selectedCategory === 'Loan Advisory') {
        return this.navbar_notifications.filter(notification => notification.noti_message.toLowerCase().includes('loan advisory'));
      } else {
        return this.navbar_notifications;
      }
    }
  },
  created(){
		if(_gAuth.isLogin()){
			this.fetchUserInfo()
			this.getUserNotifications()
			this.fetchConstantData()
		}
  },
  data() {
    return {
      activeNotifications: false,
      showMenu: false,
      searchModalVisible: false,
      searchQuery: '',
      loginUserData : '',
      selectedCategory: 'All',
      notificationCategories: ['Customer', 'Leads', 'Loan Advisory', 'All'],
      version: process.env.PACKAGE_VERSION || 0,
      modals: {
        show_tnc: false
      }
    };
  },
  methods: {
    ...mapActions(useAuthStore,['fetchUserInfo', 'fetchConstantData', 'logout']),
    ...mapActions(useNotificationStore, ['getUserNotifications', 'markAsRead', 'markAllAsRead']),
    reload(){
      location.reload(true)
    },
    markAsReadHandler(notification){
      this.markAsRead(notification)
      if(notification.noti_url){
        this.redirectNotificationURL(notification.noti_url)
      }
    },
    redirectNotificationURL(url){
      if(_gHlp.isValidURL(url)){
				window.location.href = url;
			}
    },
    viewNotificationsPage(){
      if(this.$route.name !== 'notifications'){
        this.$router.push('/notifications')
      }
    },
    async logoutFunction()
    {
      await this.logout()

      if(!this.auth_user){
        this.$router.push({name: 'Login'})
      }
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
     myProfile()
    {
      this.$router.push({name: 'My Profile'})
    },
    filterNotifications(category) {
      if (category === 'All' && this.selectedCategory === 'All') {
        this.viewNotificationsPage();
      } else {
        this.selectedCategory = category;
      }
    }
  }
};
</script>
